export default {
  print: {
    print: 'Drucken',
    segment: 'Abschnitt',
    preparingPrinting: 'Druck vorbereiten…',
    readyToPrint: 'Bereit zum Drucken'
  }
}
